import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmProject } from "@custom-types/base-types";

/** The column definition for the workspace's projects table with the field property typed */
export type WorkspaceProjectsTableGridColDef = DataGridCellParams<
  AdmProject,
  WorkspaceProjectsTableColumnField
>;

/** The column fields that can be used in the workspace's projects table */
export type WorkspaceProjectsTableColumnField =
  | "name"
  | "id"
  | "area"
  | "storageSize"
  | "archived"
  | "group"
  | "createdAt"
  | "modifiedAt"
  | "standalone"
  | "options";

/** The labels for the columns in the workspace's projects table */
export const WORKSPACE_PROJECTS_TABLE_COLUMN_LABELS: Record<
  WorkspaceProjectsTableColumnField,
  string
> = {
  name: "Name",
  id: "Project Id",
  area: "Area",
  storageSize: "Storage Size",
  archived: "Archiving State",
  group: "Group",
  createdAt: "Created At",
  modifiedAt: "Last Edited",
  standalone: "Standalone",
  options: "",
};
